class MonetaryUtils {
    static formatCurrency(value, options = {}) {
        const {
            fromCents = false
        } = options;

        if (value === null || value === undefined || value === "") {
            return "";
        }

        if (fromCents) {
            const onlyNumbers = String(value).replace(/\D/g, "");

            if (!onlyNumbers) {
                return "";
            }

            return (Number(onlyNumbers) / 100).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL"
            });
        }

        return Number(value || 0).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL"
        });
    }

    static formatPercentage(value, options = {}) {
        const {
            minimumFractionDigits = 0,
            maximumFractionDigits = 2
        } = options;

        if (value === undefined || value === null || value === "") {
            return "";
        }

        const numericValue = typeof value === "number"
            ? value
            : MonetaryUtils.parseDecimal(value);

        if (Number.isNaN(numericValue)) {
            return "";
        }

        return `${numericValue.toLocaleString("pt-BR", {
            minimumFractionDigits,
            maximumFractionDigits
        })}%`;
    };

    static calculatePercentageValue(value, percentage) {
        if (value === undefined || value === null || value === "") {
            return "";
        }

        if (percentage === undefined || percentage === null || percentage === "") {
            return "";
        }

        const numericValue = Number(value);
        const numericPercentage = Number(percentage);

        if (Number.isNaN(numericValue) || Number.isNaN(numericPercentage)) {
            return "";
        }

        return numericValue * (numericPercentage / 100);
    };

    static parseDecimal = value => {
        if (typeof value === "number") {
            return value;
        }

        const normalizedValue = String(value || "")
            .replace(/\./g, "")
            .replace(",", ".")
            .trim();

        const parsedValue = Number(normalizedValue);

        return Number.isNaN(parsedValue) ? 0 : parsedValue;
    };

    static parseCurrency = value => {
        if (typeof value === "number") {
            return value;
        }

        const onlyNumbers = String(value || "").replace(/\D/g, "");

        if (!onlyNumbers) {
            return 0;
        }

        return Number(onlyNumbers) / 100;
    };

    static normalizePercentage(value) {
        if (value === undefined || value === null || value === "") {
            return "";
        }

        const numericValue = Number(
            String(value)
                .replace("%", "")
                .replace(",", ".")
                .trim()
        );

        if (Number.isNaN(numericValue)) {
            return "";
        }

        return numericValue / 100;
    }

}
export default MonetaryUtils;